import { animated, easings, useTransition } from '@react-spring/three';
import { useThree } from '@react-three/fiber';
import { ReactNode, Suspense } from 'react';
import { usePrevious } from 'react-use';

type Props = {
  steps: ReactNode[];
  currentIndex: number;
  distance?: number;
};
export const TransitionSteps = ({ steps, currentIndex, distance }: Props) => {
  const {
    viewport: { width },
  } = useThree();

  const stepDistance = distance ?? width;

  const previousIndex = usePrevious(currentIndex) ?? currentIndex;

  const transitions = useTransition(currentIndex, {
    from: {
      positionX: Math.sign(currentIndex - previousIndex) * stepDistance * 2,
    },
    enter: { positionX: 0 },
    leave: {
      positionX: Math.sign(previousIndex - currentIndex) * stepDistance * 2,
    },
    config: {
      duration: 500,
      easing: easings.easeInOutSine,
      precision: 0.0001,
    },
  });

  return (
    <>
      {transitions((style, index) => {
        return (
          <animated.group
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            position-x={style.positionX}
          >
            {steps[index]}
          </animated.group>
        );
      })}
      {/* preload next element but hidden */}
      {currentIndex + 1 < steps.length && (
        <Suspense>
          {/* move element away so it's not interactable */}
          <group visible={false} scale={0} position-y={10}>
            {steps[currentIndex + 1]}
          </group>
        </Suspense>
      )}
    </>
  );
};

export default TransitionSteps;
